var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"error-tooltip"},[_c('dash-icon',{attrs:{"icon":"tooltip-error"}}),_vm._v(" "+_vm._s(_vm.error)+" ")],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }